import React, { useContext } from "react";
import Button from "react-bootstrap/Button";
import { HeaderContext, NavContext } from "contexts";
import { Icon } from "@components/Icons";

export default function MenuBtn() {
	const { setMegaNavName } = useContext(NavContext);

	const { isMobileNavOpen, setIsMobileNavOpen } = useContext(HeaderContext);

	const handleClick = () => {
		setIsMobileNavOpen((isMobileNavOpen) => {
			setMegaNavName("");
			return !isMobileNavOpen;
		});
	};

	//positioning the relative icons which overlap, but use opacity to fade in and out
	const iconMarginRight = "0.5em";
	const closeIconLeft = "-1.75em";
	return (
		<Button onClick={handleClick} className="py-3 d-inline-flex closeOffset" variant="MENU">
			{/* HAMBURGER ICON */}
			<div className={`relative d-flex ${!isMobileNavOpen ? "show" : "fade"}`}>
				<Icon icon="hamburger" style={{ marginRight: iconMarginRight }} />
			</div>
			{/* CLOSE ICON */}
			<div style={{ left: closeIconLeft }} className={`d-flex relative  ${isMobileNavOpen ? "show" : "fade"}`}>
				<Icon icon="close" style={{ marginRight: iconMarginRight }} />
			</div>

			<span className={`relative open ${isMobileNavOpen ? "show" : "fade"} `}>CLOSE</span>
			<span className={`relative close ${!isMobileNavOpen ? "show" : "fade"} `}>MENU</span>

			<style jsx>{`
				.closeOffset {
					padding-left: 4em !important;
					width: 90px !important;
				}

				.open {
					left: -1.5em;
				}
				.close {
					left: -4.5em;
				}
			`}</style>
		</Button>
	);
}
